import { useTranslation } from "react-i18next";
import { useState } from "react";
import { CreatePolicyType } from "./type";
import { createInitialState } from "./state";
import RenewalHeader from "./RenewalHeader";
import classNamePresets from "../../../utils/classNamePresets";
import { H2 } from "../../../components/basics";
import PolicyDetails from "./PolicyDetails";
import agentApiService, { RenewalCheckoutRequest } from "../../../services/pay_now/agentApiService";
import { Region } from "../../../enums/shared/forms/Region";
import { Footer } from "../../tpa/components/Footer";

const RenewalPolicyDetails = () => {
  const { t } = useTranslation("pages", { keyPrefix: "travel.payNow" });
  const { t: footer } = useTranslation("pages", { keyPrefix: "travel.payNow.sgFooter" });
  const [state, setState] = useState<CreatePolicyType>(createInitialState);
  const [submitting, setSubmitting] = useState<boolean>(false);

  const handleSubmit = async () => {
    const requestData: RenewalCheckoutRequest = {
      insuredName: state.insuredName,
      policyNumber: state.policyNumber,
      contactNumber: state.contactNumber,
      email: state.email,
      amount: parseFloat(state.amount),
      type: Region.SG,
    };
    try {
      setSubmitting(true);
      const response = await agentApiService.genericCheckout(requestData);
      window.location.href = response.url;
    } catch (error) {
      console.error(error);
      setSubmitting(false);
    }
  };

  return (
    <div className="flex flex-col min-h-screen gap-0">
      <RenewalHeader />
      <div className="container-flow flex-grow md:pt-[64px] pt-8">
        {/* Paynow SG generic policy details screen */}
        <H2 className={classNamePresets.mainHeading}>{t("title")}</H2>
        <p>{t("subtitle")}</p>
        <PolicyDetails t={t} state={state} setState={setState} onSubmit={handleSubmit} submitting={submitting} />
      </div>
      <Footer footer={footer} />
    </div>
  );
};

export default RenewalPolicyDetails;
